import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Switcher from 'components/Switcher';
import SVG from 'components/SVG';
import Input from 'components/Input';
import Button from 'components/Button';
import InputPhoto from 'components/InputPhoto/mobile';

import settingsSVG from 'features/bonusProgram/data/img/settings.svg';
import imageSVG from 'features/bonusProgram/data/img/image.svg';
import useCreateBonusGift from '../../../../model/useCreateBonusGift';

import './GiftEditor.scss';

const b = block('gift-editor-desktop');

const GiftEditor = () => {
  const locale = useSelector(s => s.locale.locale);
  const { values, handlers } = useCreateBonusGift();

  return (
    <form className={b()} onSubmit={handlers.handleSaveClick}>
      <section className={b('block')}>
        <div className={b('block-header')}>
          <SVG className={b('icon')} svgProps={{ svg: settingsSVG }} />
          {locale.settings}
        </div>

        <div className={b('block-content')}>
          <div className={b('row')}>
            <div className={b('text')}>{locale.active}</div>

            <div className={b('switcher')}>
              <Switcher
                isActive={values.state.active}
                onSwitch={() => handlers.handleActiveChange(!values.state.active)}
              />
            </div>
          </div>

          <div className={b('row')}>
            <div className={b('item')}>
              <div className={b('item-label')}>{locale.nameGift}</div>
              <div className={b('item-field')}>
                <Input
                  value={values.state.name}
                  onChange={e => handlers.handleNameChange(e.currentTarget.value)}
                  placeholder={locale.nameGift}
                />
              </div>
            </div>

            <div className={b('item')}>
              <div className={b('item-label')}>{locale.numberOfPoints}</div>
              <div className={b('item-field')}>
                <Input
                  type="number"
                  value={values.state.points}
                  onChange={e => handlers.handlePointsChange(e.currentTarget.value)}
                  placeholder="0"
                />
              </div>
            </div>
          </div>

          <div className={b('item', { type: 'grow' })}>
            <div className={b('item-label')}>{locale.description}</div>
            <textarea
              className={b('item-area')}
              value={values.state.description}
              onChange={e => handlers.handleDescriptionChange(e.currentTarget.value)}
              placeholder={locale.noMore30}
             />
          </div>
        </div>
      </section>

      <section className={b('block')}>
        <div className={b('block-header')}>
          <SVG className={b('icon')} svgProps={{ svg: imageSVG }} />
          {locale.image}
        </div>

        <div className={b('block-content', { type: 'image' })}>
          <div className={b('text')}>{locale.image}</div>
          <div className={b('photo')}>
            <InputPhoto
              currentImageData={values.state.imageData}
              onImageChange={handlers.handleImageDataChange}
              url={values.state.imageUrl}
            />
          </div>
          <div className={b('description')}>{locale.imageDescription}</div>
        </div>
      </section>
      <section className={b('buttons')}>
        <div className={b('button')}>
          <Button text={locale.cancel} type="button" callBack={handlers.handleCancelClick} color="transparent" />
        </div>
        <div />
        <div className={b('button')}>
          <Button text={locale.save} type="submit" disabled={values.disabled} />
        </div>
      </section>
    </form>
  );
};

export default GiftEditor;
